'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (text) {
    return text.split(')').length > 1 ? text.split(')')[1] : text;
};